import React from 'react';
import { generatePath, useParams } from 'react-router-dom';

import FinancialDashboardNavigation from 'components/FinancialCheckup/FinancialDashboardNavigation';
import Plaid from 'components/Verification/Steps/CheckingAccount/Plaid';
import { RoutePath } from 'enums/Routes';
import { useNavigate } from 'hooks/useNavigate';
import { FlowComponentType } from 'routes/types';

const UpdateAchConnect = ({ navigationInfo, handleNext }: FlowComponentType) => {
  const navigate = useNavigate();
  const { loanId } = useParams<{ loanId: string }>();

  const handleBackClick = () => {
    navigate(generatePath(RoutePath.PaymentSettings, { loanId }) as RoutePath);
  };

  return (
    <Plaid
      handleNext={handleNext}
      isAchUpdateFlow
      NavigationComponent={FinancialDashboardNavigation}
      navigationInfo={navigationInfo}
      onBackClick={handleBackClick}
    />
  );
};

export default UpdateAchConnect;
